<template>
  <div
    class="image-with-vignette"
    ref="imageWithVignette"
    v-bind:style="roundBordersStyle"
  >
    <div
      class="image-wrapper"
      v-bind:style="roundBordersStyle"
    >
      <slot><!-- placeholder for an image --></slot>
    </div>
    <div
      class="vignette"
      v-bind:style="Object.assign(
        {}, vignetteStyle, roundBordersStyle)"
    ></div>
  </div>
</template>

<script>
function validatePercentLikeNumber (value) {
  return (value >= 0) && (value <= 100)
}
export default {
  name: 'Vignette',
  props: {
    'vignette-size': {
      type: Number,
      default: 15,
      validator: validatePercentLikeNumber
    },
    'vignette-blur': {
      type: Number,
      default: 15,
      validator: validatePercentLikeNumber
    },
    'vignette-color': {
      type: String,
      default: 'black'
    },
    'border-radius': {
      type: Number,
      default: 0,
      validator: validatePercentLikeNumber
    }
  },
  data: function () {
    return {
      width: 0,
      height: 0
    }
  },
  created () {
    window.addEventListener('resize', this.updateImageSize)
  },
  destroyed () {
    window.removeEventListener('resize', this.updateImageSize)
  },
  mounted () {
    this.$slots.default[0].elm.onload = this.updateImageSize
    // this is to hide annoying border effects in Chrome
    Object.assign(this.$slots.default[0].elm.style, this.roundBordersStyle)
  },
  computed: {
    roundBordersStyle: function () {
      const style = {
        borderRadius: `${this.borderRadius}%`,
        overflow: 'hidden'
      }
      return (this.borderRadius > 0) ? style : {}
    },
    vignetteStyle: function () {
      const minDimension = Math.min(this.width, this.height)
      const size = minDimension * this.vignetteSize / 100
      const blur = minDimension * this.vignetteBlur / 100
      return {
        boxShadow: `inset 0 0 ${blur}px ${size}px ${this.vignetteColor}`
      }
    }
  },
  methods: {
    updateImageSize: function () {
      this.width = this.$refs.imageWithVignette.clientWidth
      this.height = this.$refs.imageWithVignette.clientHeight
    }
  }
}
</script>

<style scoped lang="scss">
  .image-with-vignette {
    position: relative;
    & > .image-wrapper > img {
      display: block;
      max-width: 100%;
      height: auto;
    }
    & > .vignette {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/utils/Vignette.vue